import { quartInOut } from 'svelte/easing';
import type { TransitionConfig } from 'svelte/transition';

const outDuration = 600;
const inDuration = 400;
const easing = quartInOut;

export const menuContainerInOut = (
	node: HTMLElement,
	_: undefined,
	options: { direction: 'in' | 'out' | 'both' }
): TransitionConfig => {
	const existingTransform = getComputedStyle(node).transform.replace('none', '');

	return {
		duration: Math.max(outDuration, inDuration),
		delay: options.direction === 'out' ? 200 : 0,
		easing,
		css: (_, u) => `transform: ${existingTransform} translateY(${-100 * u}%);`
	};
};

export const menuContentInOut = (
	node: HTMLElement,
	_: undefined,
	options: { direction: 'in' | 'out' | 'both' }
): TransitionConfig => {
	const position = options.direction === 'in' ? -40 : 40;
	const index = options.direction === 'in' ? 21 : 19;

	const existingTransform = getComputedStyle(node).transform.replace('none', '');

	let duration = outDuration;
	if (options.direction === 'in') {
		duration += inDuration;
	}

	return {
		duration,
		easing,
		css: (_, u) => {
			const delayed = options.direction === 'in' ? Math.min(1, u * 1.5) : u;
			const t = 1 - delayed;
			return `transform: ${existingTransform} translateY(${position * delayed}px); opacity: ${1 * t}; z-index: ${index};`;
		}
	};
};

export const menuBlockIn = (_: HTMLElement): TransitionConfig => {
	return {
		duration: inDuration + outDuration,
		easing,
		css: (t) => `opacity: ${1 * t}; z-index: 21;`
	};
};
